module.exports = __webpack_public_path__ + "static/Garo-59f6b515e5e8ce95cc6fd97e4b8b582f.png";